import { ApiProperty } from "@nestjs/swagger";
import { Timestamp } from "typeorm";

export class AttendanceLogRequest {
    @ApiProperty()
    logDate: string;
    @ApiProperty()
    employeeCode: string;
    @ApiProperty()
    downloadDate: string;
    @ApiProperty()
    verifyMode: string;
    @ApiProperty()
    deviceCode: string;
    @ApiProperty()
    direction: string;
    @ApiProperty()
    employeeName: string;

    /**
     * 
     * @param logDate 
     * @param employeeCode 
     * @param downloadDate 
     * @param verifyMode 
     * @param deviceCode 
     * @param direction 
     * @param employeeName 
     */
    constructor(logDate: string, employeeCode: string, downloadDate: string, verifyMode: string, deviceCode: string, direction: string, employeeName: string) {
        this.logDate = logDate;
        this.employeeCode = employeeCode;
        this.downloadDate = downloadDate;
        this.verifyMode = verifyMode;
        this.deviceCode = deviceCode;
        this.direction = direction;
        this.employeeName = employeeName;
    }
}